import { IonBackButton, IonButtons, IonCard, IonCardContent, IonContent, IonHeader, IonLabel, IonLoading, IonPage, IonSegment, IonSegmentButton, IonTitle, IonToolbar } from "@ionic/react";
import React, { useContext, useEffect, useRef, useState } from "react";
import Header from "../../components/Header/Header";
import { CreateCustomSurvey } from "../../components/SurveyForms/CreateCustomSurvey";
import { Model, SurveyModel } from "survey-core";
// import { json } from "../../components/SurveyForms/json";
// import { LayeredDarkPanelless } from "survey-core/themes/layered-dark-panelless";
import { medlineSurveyJson } from "../../components/SurveyForms/medlineJson";
import SurveyFields from "./SurveyFields";
import { Box, Button, createTheme, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Drawer, TextareaAutosize, ThemeProvider, Typography } from "@mui/material";
import MaterialTable, { Column } from "material-table";
import tableIcons from "../../components/Notifications/MaterialTableIcons";
import { ApplicationContext, ProviderContext } from "../../ApplicationState";
import * as ApiService from "../../services/ApiService";
import { useHistory, useLocation } from "react-router";
import { arrowBackCircleSharp, returnDownForward } from "ionicons/icons";
import { SurveyPDF } from "survey-pdf";
import { Icon } from '@iconify/react';
import * as Helpers from "../../services/Helpers";
import saveAs from "save-as";
import { useTranslations } from "../../hooks/useTranslations";

/**
 *** Refer to this github link to apply custom css to survey forms ***
 * https://github.com/surveyjs/survey-library/blob/master/src/defaultCss/cssmodern.ts
 */
var _ = require("lodash");

const customCss = {
    "headerText": "sv-header__text",
}

export const Survey = () => {
    const { userState } = useContext(ApplicationContext)
    const { providerState } = useContext(ProviderContext)
    const [selectedDefaults, setSelectedDefaults] = useState('Templates')
    const [submitted, setSubmitted] = useState(false)
    const tableRef = useRef(null)
    const [loading, setLoading] = useState(false)
    const [surveys, setSurveys] = useState([])

    const [edit, setEdit] = useState(false)
    const history = useHistory();
    const location = useLocation();

    const [providers, setProviders] = useState<any[]>([]);
    const [selectedProviders, setSelectedProviders] = useState<any[]>([]);
    const [openDeleteModal, setOpenDeleteModal] = React.useState(false);
    const [openCopyModal, setOpenCopyModal] = React.useState({ value: false, row: null });
    const [openProviderModal, setOpenProviderModal] = React.useState(false);

    const [rowData, setrowData] = React.useState(null);
    const [tempRowData, setTempRowData] = React.useState('');

    const [selectedSurvey, setSelectedSurvey] = useState(null);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [selectedSurveyNotes, setSelectedSurveyNotes] = useState([]);
    const [text, setText] = React.useState("");

    const defaultMaterialTheme = createTheme()

    const labels = useTranslations()

    const groupsColumns: Column<any>[] = [
        {
            field: "surveyName",
            title: labels.SurveyName,
            width: 0,
            editable: 'onUpdate'
        },

        {
            field: "surveyDescription",
            title: labels.SurveyDescription,
            width: 0,
            editable: 'onUpdate'
        },

        {
            field: "details",
            title: labels.CreateSurvey,
            width: 0,
            editable: 'never',
            render: rowData => {

                return (
                    <Button
                        style={{ cursor: 'pointer' }}
                        disabled={!rowData.isEditable}
                        onClick={() => {
                            history.push("/createSurvey", { rowData: rowData });
                        }} variant="contained">{labels.Edit}</Button>
                )
            }
        },
        {
            field: "surveyLink",
            title: labels.Preview,
            width: 0,
            editable: 'never',
            render: rowData => {
                const underReview = (rowData?.status === undefined) || (rowData?.status === null) ? 'Draft' : rowData?.status
                return (
                    <Button
                        style={{ fontSize: 11, alignSelf: 'center', cursor: 'pointer' }}
                        //hidden={rowData.surveyLink === null ? true : false}
                        onClick={() => {
                            window.open(`/survey/${rowData.id}?access_token=${userState.authenticatedUser.signInUserSession.accessToken.jwtToken}&username=${userState.authenticatedUser.username}&sch_type=${'fromWeb'}&status=${underReview}`, '_blank') //will open in a new tab to bypass login page.
                        }}
                        variant='contained'>
                        {labels.PreviewNewTab}</Button>
                )
            }
        },

        {
            field: "download",
            title: labels.Download,
            width: 0,
            editable: 'never',
            render: rowData => {
                return (

                    <Icon
                        onClick={() => {
                            handleDownload(rowData)
                        }}
                        icon="material-symbols:download"
                        width="30"
                        height="30"
                        style={{
                            alignSelf: 'flex-end',
                            color: 'white',
                            marginLeft: 20,
                            cursor: 'pointer',
                            backgroundColor: '#165fc7',
                            borderRadius: 15,
                            padding: 2
                        }} />


                    // <Button onClick={() => {
                    //     handleDownload(rowData)
                    // }} variant="contained">Download</Button>
                )
            }
        },
        {
            field: "status",
            title: labels.Status,
            width: 0,
            editable: 'never',
            render: rowData => {
                return (
                    <IonLabel style={{
                        color: (rowData?.status === "Under Review") || (rowData?.status === "Rejected") ? 'brown' : 'green',
                        backgroundColor: (rowData?.status === "Under Review") || (rowData?.status === "Rejected") ? '#FFEBE8' : ((rowData?.status === null) || (rowData?.status === undefined) ? 'white' : '#E8FFEB'),
                        padding: '5px 10px',
                        borderRadius: '5px',
                    }}>{labels.widgetItemName(rowData?.status)}</IonLabel>
                )
            }
        },

        {
            field: "delete",
            title: labels.Delete,
            width: 0,
            editable: 'never',
            render: rowData => {
                const approved = (rowData.status === 'Approved') || (rowData.status === 'Draft') || (rowData.status === null)
                {
                    return approved && (
                        <Icon
                            onClick={() => {
                                handleDelete(rowData)
                            }}
                            icon="ic:round-cancel"
                            color="red"
                            width="30"
                            style={{ alignSelf: 'center', marginLeft: 20, cursor: 'pointer' }} />
                    )
                }

                // <Button
                //     hidden={!rowData.isEditable}
                //     onClick={() => {
                //         handleDelete(rowData)
                //     }} variant="contained">Remove</Button>

            }
        },

        {
            field: "note",
            title: labels.Note,
            width: 0,
            editable: 'never',
            render: rowData => {
                return (
                    rowData?.notes ? (
                        <Icon
                            onClick={() => {
                                openSidebar(rowData)
                            }}
                            icon="material-symbols:comment-outline"
                            width="35"
                            height="35"
                            style={{
                                cursor: 'pointer',
                                backgroundColor: '#165fc7',
                                borderRadius: 15,
                                padding: 5,
                                color: 'white',
                            }} />
                    ) : null
                )
            }
        },

        {
            field: "createcopy",
            title: labels.CreateCopy,
            width: 0,
            editable: 'never',
            render: rowData => {
                return (
                    <Icon
                        onClick={() => {
                            createCopy(rowData)
                        }}
                        icon="material-symbols:content-copy-outline"
                        width="35"
                        height="35"
                        style={{
                            cursor: 'pointer',
                            backgroundColor: '#165fc7',
                            borderRadius: 15,
                            padding: 5,
                            color: 'white',
                        }} />
                )
            }
        },

        // {
        //     field: "edittitle",
        //     title: "Edit Title",
        //     width: 0,
        //     render: rowData => {
        //         return (
        //             <Icon
        //                 onClick={() => {

        //                 }}
        //                 icon="material-symbols:edit-outline"
        //                 width="30"
        //                 height="30"
        //                 style={{
        //                     cursor: 'pointer',
        //                     backgroundColor: '#165fc7',
        //                     borderRadius: 15,
        //                     padding: 5,
        //                     color: 'white',
        //                 }} />
        //         )
        //     }
        // },
    ];

    const createCopy = (row) => {
        setOpenCopyModal({
            value: true,
            row: row
        })
    }

    // Open sidebar with selected note
    const openSidebar = (row) => {
        setText(row?.notes)
        setSelectedSurvey(row);
        setIsSidebarOpen(true);
    };

    // Close sidebar
    const closeSidebar = () => {
        setText('')
        setIsSidebarOpen(false);
    };


    const handleDownload = (rowData) => {
        const pdfExporter = new SurveyPDF(JSON.parse(rowData.jsonData));
        //const survey = new SurveyModel(JSON.parse(rowData));
        pdfExporter.save("survey-result.pdf");
        //setrowData(rowData?.id)
        // setOpenDeleteModal(true)
    }

    const handleDelete = (rowData) => {
        setrowData(rowData)
        setOpenDeleteModal(true)
    }

    const survey = new Model(medlineSurveyJson) //instantiate a model, pass the model schema to the Model constructor

    //Handle survey complete submission in a callback response
    survey.onComplete.add((sender, options) => {
        //TODO: After survey complete, send them to server to stored in DB here.
        setSubmitted(true)
        alert('Form Submitted')

    })
    //survey.applyTheme(LayeredDarkPanelless)

    survey.css = customCss //apply css

    // survey.applyTheme({
    //     "cssVariables": {
    //         "color": "rgba(246,246,246,1)"
    //     },
    //     "themeName": "doubleborder",
    //     "colorPalette": "dark",
    //     "isPanelless": false
    // });

    const resetSurvey = () => {
        setSubmitted(false)
    }

    useEffect(() => {
        setLoading(true)
        try {
            ApiService.getSurveys(userState.authenticatedUser, providerState.providerId).then(res => {

                setLoading(false)
                if (res) {
                    const surveyItem = _.map(res, data => {
                        return {
                            id: data.uId,
                            surveyName: data.name,
                            surveyDescription: data.description,
                            surveyLink: data.surveyLink,
                            jsonData: data.jsonData,
                            createdOn: data.createdOn,
                            isEditable: data.isEditable,
                            status: data.status,
                            notes: data.notes
                        }
                    })

                    const sortBydate: any = surveyItem.sort((a, b) => {
                        const date2 = new Date(b.createdOn).getTime();
                        const date1 = new Date(a.createdOn).getTime();
                        return date2 - date1
                    });

                    setSurveys(sortBydate)

                }
            }).catch(error => {
                setLoading(false)

                //alert('Issues getting the groups. Please try again.')
            })
        } catch (ex) {
            setLoading(false)
            console.log("ðŸš€ ~ Issues getting the groups. Please try again. ~ ex:")
        }

    }, [providerState, location.pathname])

    useEffect(() => {
        setLoading(true)
        setSelectedProviders([providerState.providerName + '(' + providerState.providerId + ')'])
        ApiService.fetchProviders(userState.authenticatedUser).then((data) => {
            setLoading(false)
            if (data && data.length > 0) {
                setProviders(data);
            }
        }).catch(err => {
            setLoading(false)
        })
    }, [providerState, location.pathname])

    const onProviderSelect = (value) => {

        setSelectedProviders(value.detail.value)
    }

    const handleAddSurvey = (surveyName: string, surveyDesc: string, fromCopy: boolean, jsonData: any) => {
        if (_.isEmpty(surveyName)) {
            alert(labels.SurveyNamecannotempty)
            return
        }

        const data = {
            name: surveyName,
            JsonData: jsonData,
            description: surveyDesc,
            createdOn: new Date(),
            UpdatedOn: new Date(),
            userId: userState.authenticatedUser.username,
            isEditable: true,
            providers: !_.isEmpty(selectedProviders) ? selectedProviders : [providerState.providerName + '(' + providerState.providerId + ')']
        }

        setLoading(true)

        ApiService.createSurvey(userState.authenticatedUser, data).then((res) => {

            if (res.status === 200) {
                const sameProviderIdSurvey = _.filter(res.data, r => r.providerId === providerState.providerId)
                const surveyname = fromCopy ? sameProviderIdSurvey[0].name + '(copy)' : sameProviderIdSurvey[0].name
                setLoading(false)
                setSurveys([
                    {
                        id: sameProviderIdSurvey[0].uId,
                        surveyName: surveyname,
                        surveyDescription: sameProviderIdSurvey[0].description,
                        surveyLink: sameProviderIdSurvey[0].surveyLink,
                        isEditable: sameProviderIdSurvey[0].isEditable,
                        jsonData: sameProviderIdSurvey[0].jsonData,
                        status: 'Draft'
                    },
                    ...surveys
                ])

            }
        }).catch(err => {
            setLoading(false)
            alert(labels.Somethingwentwrong)
        })
    }

    const handleYes = () => {
        if (rowData?.status === 'Draft' || rowData?.status === null) {
            deleteFromTempTable(rowData?.id)
            return
        }

        if (rowData?.status === 'Approved') {
            deleteApprovedSurvey(rowData?.id)
            return
        }
    }

    const deleteFromTempTable = (rowData) => {
        ApiService.deleteTempSurvey(userState.authenticatedUser, rowData).then((res) => {
            if (res.status === 200) {
                const filterdeletedSurvey = _.filter(surveys, ele => {
                    return ele.id !== res.data.uId
                })
                setSurveys(filterdeletedSurvey)
                setOpenDeleteModal(false)
                alert(`${labels.Survey} ${labels.Remove}d!`)
            }
        }).catch(err => {
            setOpenDeleteModal(false)
            alert(labels.Somethingwentwrong)
        })
    }

    const deleteApprovedSurvey = (rowData) => {
        ApiService.deleteSurvey(userState.authenticatedUser, rowData).then((res) => {
            if (res.status === 200) {
                const filterdeletedSurvey = _.filter(surveys, ele => {
                    return ele.id !== res.data.uId
                })
                setSurveys(filterdeletedSurvey)
                setOpenDeleteModal(false)
                alert(`${labels.Survey} ${labels.Delete}d!`)
            }
        }).catch(err => {
            setOpenDeleteModal(false)
            alert(labels.Somethingwentwrong)
        })
    }

    const handleDownloadNotes = () => {
        const base64Content = btoa(text);
        const downloadedFile = Helpers.base64ToBlob(
            base64Content,
            text
        );
        saveAs(downloadedFile);
    }

    return (
        <IonPage>
            <Header />
            <IonHeader>
                <IonToolbar color="light">
                    <IonButtons slot="start">
                        <IonBackButton
                            text={labels.Goback}
                            icon={arrowBackCircleSharp}
                            defaultHref="/"
                        />
                    </IonButtons>
                    <IonTitle>{labels.MySurveys}</IonTitle>
                </IonToolbar>
            </IonHeader>

            <IonContent style={{ backgroundColor: "white", overflow: "scroll", display: "flex" }}>

                <IonCard style={{ width: "100%", backgroundColor: "white" }}>
                    <SurveyFields selectedProviders={selectedProviders} providers={providers} handleAddGroups={handleAddSurvey} onProviderSelect={onProviderSelect} />

                    <IonCardContent>
                        <ThemeProvider theme={defaultMaterialTheme}>
                            <MaterialTable
                                tableRef={tableRef}
                                localization={{
                                    body: {
                                        emptyDataSourceMessage: (
                                            <Typography>
                                                {labels.Nosurveystodisplay}
                                            </Typography>
                                        ),
                                        editRow: {
                                            saveTooltip: labels.SAVE,
                                            cancelTooltip: labels.cancel
                                        },
                                        editTooltip: labels.Edit
                                    },
                                    header: {
                                        actions: labels.Edit
                                    },
                                    toolbar: {
                                        searchPlaceholder: labels.Search
                                    },
                                    pagination: {
                                        labelRowsPerPage: labels.RowsPerPage,
                                        labelRowsSelect: labels.rows
                                    }

                                }}
                                style={{ width: "100%" }}
                                title=""
                                icons={tableIcons}
                                columns={groupsColumns}
                                options={{
                                    pageSizeOptions: [5, 10],
                                    defaultExpanded: true,

                                }}
                                components={{
                                    OverlayLoading: props => (<div style={{ justifyContent: "center", alignItems: 'center' }}> {labels.Loading}... </div>)
                                }}
                                // isLoading={groupArray.length === 0 || groupArray === null}
                                page={5}
                                data={surveys === null ? [] : surveys}

                                editable={{
                                    isEditHidden: rowData => {
                                        return rowData.status === 'Under Review' || rowData.status === 'Approved'
                                    },
                                    // onRowAdd: newData => {
                                    //     console.log('new dataonRowAdd  ', newData)
                                    //     return new Promise((resolve, reject) => {
                                    //         setTimeout(() => {
                                    //             setSurveys([...surveys, newData]);
                                    //             resolve();
                                    //         }, 1000)
                                    //     })
                                    // },
                                    onRowUpdate: (newData, oldData) => {
                                        const dataUpdate = [...surveys];

                                        const index = oldData.tableData.id;

                                        dataUpdate[index] = newData;

                                        const data = {
                                            providerId: providerState.id,
                                            name: newData?.surveyName,
                                            JsonData: newData?.jsondata,
                                            description: newData?.surveyDescription,
                                            UpdatedOn: new Date(),
                                            userId: userState.authenticatedUser.username,
                                            notes: newData?.notes,
                                            status: newData?.status,
                                            isEditable: newData?.isEditable
                                        }

                                        return ApiService.updateTitleForSurvey(userState.authenticatedUser, data, newData?.id).then(res => {
                                            if (res?.status === 200) {
                                                setSurveys([...dataUpdate]);
                                            }
                                        }).catch(err => {
                                            alert(labels.Somethingwentwrong)
                                        })
                                    }
                                }}
                            //onRowClick={(event, rowData, togglePanel) => togglePanel()}
                            />
                        </ThemeProvider>
                        <IonLoading
                            cssClass="my-custom-class"
                            isOpen={loading}
                            onDidDismiss={() => setLoading(false)}
                            message={`${labels.Pleasewait}...`}
                            duration={5000}
                        />
                    </IonCardContent>
                </IonCard>
            </IonContent>


            <Dialog
                open={openDeleteModal}
                onClose={() => setOpenDeleteModal(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {labels.DeletingSurvey}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {labels.Areyousureyoudeletethissurvey}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDeleteModal(false)}>No</Button>
                    <Button onClick={handleYes} autoFocus>
                        {labels.Yes}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openCopyModal.value}
                onClose={() => setOpenCopyModal({
                    value: false,
                    row: null
                })}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {labels.CopySurvey}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {labels.Doyouwanttocreateacopysurvey}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenCopyModal({
                        value: false,
                        row: null
                    })}>No</Button>
                    <Button
                        onClick={() => {
                            const surveyName = openCopyModal?.row?.surveyName
                            const surveyDesc = openCopyModal?.row?.surveyDescription
                            const jsonData = openCopyModal?.row?.jsonData
                            handleAddSurvey(surveyName, surveyDesc, true, jsonData)
                            setOpenCopyModal({
                                value: false,
                                row: null
                            })
                        }}
                        autoFocus>
                        {labels.Yes}
                    </Button>
                </DialogActions>
            </Dialog>

            <Drawer
                anchor='right'
                open={isSidebarOpen}
                onClose={() => {
                    closeSidebar()
                }}>
                <div className="container">
                    <TextareaAutosize
                        disabled={true}
                        contentEditable={false}
                        className="textArea"
                        minRows={3}
                        style={{ height: '50%' }}
                        value={text}
                    />
                    <div className="button-container">
                        <button className="close-btn" onClick={closeSidebar}>{labels.Close}</button>
                        <button className="save-btn" onClick={handleDownloadNotes}>{labels.Download}</button>

                    </div>
                </div>

            </Drawer>
        </IonPage >
    )
}